import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "./lt";

Drupal.behaviors.commentToggleBehaviour = {
  attach: function (context, settings) {
    dayjs.locale("lt");
    dayjs.extend(relativeTime);
    // Your code here, with 'context' to target specific parts of the DOM
    let textarea = once(
      "commentTextArea",
      ".article-comments form textarea",
      context
    );
   /*  let comments_date = once(
      "commentDate",
      ".article-comment-author-info .comment-date",
      context
    ); */

    textarea.forEach(element => { 
      checkIfTextAreaFocused(element);
      setRelativeCommentTime();
    });
  },
};

const setRelativeCommentTime = () => {
  let comments_date = document.querySelectorAll(
    ".article-comment-author-info > .comment-date"
  );
  
  comments_date.forEach((date) => {
    date.innerHTML = dayjs.unix(date.dataset.commentTimestamp).fromNow();
  });
};

const checkIfTextAreaFocused = (textarea) => {
  /* let article_comment_form_textarea = document.querySelector(
    ".comment-comment-form textarea"
  ); */
  let article_comment_form_textfield = document.querySelector(
    ".comment-comment-form input[type='text']"
  );

  let button_cancel_comment = document.querySelector(
    ".comment-comment-form .button-cancel-comment"
  );
  let article_comment_form_submit = document.querySelector(
    '.comment-comment-form input[type="submit"]'
  );

  if (textarea) {
    textarea.addEventListener("click", () => {
      textarea.classList.add(
        "article-comment-form-textarea-active"
      );
      article_comment_form_submit.style.display = "inline-block";
      button_cancel_comment.style.display = "inline-block";
      if (article_comment_form_textfield) {
        article_comment_form_textfield.style.display = "block";
      }
    });
  }

  if (button_cancel_comment) {
    button_cancel_comment.addEventListener("click", (e) => {
      textarea.classList.remove(
        "article-comment-form-textarea-active"
      );
      article_comment_form_submit.style.display = "none";
      button_cancel_comment.style.display = "none";
      if (article_comment_form_textfield) {
        article_comment_form_textfield.style.display = "none";
      }
      e.preventDefault();
    });
  }
};

const setRelativeCommentTimeMutationObserver = () => {
  let comments_wrapper = document.querySelector(
    ".article-comments .comments-content-wrapper"
  );
  const observer = new MutationObserver(() => {
    setRelativeCommentTime();
    checkIfTextAreaFocused();
    observer.disconnect();
    observer.observe(comments_wrapper, { subtree: true, childList: true });
  });

  // call `observe()` on that MutationObserver instance,
  // passing it the element to observe, and the options object
  observer.observe(comments_wrapper, { subtree: true, childList: true });
};
